import { useResourceFormContext as useFrameworkFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { useResourceFormQuery } from "src/components/Form/hooks/useResourceFormQuery.ts";

export const useResourceFormDisableSaving = () => {
  const { data } = useResourceFormQuery();

  const { action, disableSaving } = useFrameworkFormContext();

  return typeof disableSaving === "function"
    ? disableSaving({
        data,
        type: action,
      })
    : disableSaving;
};
